import { Platform } from 'react-native';
import * as ExpoCrypto from 'expo-crypto';

/**
 * A v4 UUID that also works on an insecure web origin.
 *
 * expo-crypto's web build calls `crypto.randomUUID()` bare, and that API is
 * secure-context-gated — so on `http://<lan-ip>:3000` the "Add measure"
 * buttons threw inside their press handlers and did nothing. Native goes
 * straight to expo-crypto, which has no such restriction.
 *
 * `crypto.getRandomValues` is NOT gated, and sixteen random bytes with the
 * version and variant bits set is exactly what `randomUUID` produces.
 */
export function randomUUID(): string {
  if (Platform.OS !== 'web') return ExpoCrypto.randomUUID();

  const c = globalThis.crypto;
  if (typeof c?.randomUUID === 'function') return c.randomUUID();

  const b = new Uint8Array(16);
  c.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, '0')).join('');
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
